import React from 'react';
import { useFormContext } from "react-hook-form";
import { translate } from "../../Services/translation";

const PartialShipping = ({deliveryOptions}) => {
    const { register } = useFormContext();

    if(deliveryOptions.length === 0){
        return null;
    }

    return (
        <div className="checkout__partial-shipping-container">
            <p className="checkout__label checkout__label--radio">{translate('checkout.form.deliveryalternative.label')}</p>
            <p className="checkout__text">{translate('checkout.form.deliveryalternative.text')}</p>
            <div>
                <div className="checkout__radio-container">
                    {
                        deliveryOptions.map(x => (
                            <div>
                                <input
                                    className="checkout__radio-button"
                                    id={"partial-delivery-" + x.key}
                                    type="radio"
                                    value={x.key}
                                    {...register('partialShipping')}
                                    defaultChecked={x.checked}
                                />
                                <label htmlFor={"partial-delivery-" + x.key}
                                       className="checkout__radio-label">{translate(x.text)} {x.price && <span>- {x.price}</span>}</label>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default PartialShipping;
